export interface IFileResponse {
    fileUrl: string;
    fileName: string;
    errorMessage?: string;
}

export class FileResponseClass implements IFileResponse {
    public fileUrl: string;
    public fileName: string;
    public errorMessage?: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.fileUrl = odataObject.fileUrl;
        this.fileName = odataObject.fileName;
        this.errorMessage = odataObject.errorMessage;
    }
}

export class BusinessSegment {
    public segment: string;
    public description: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.segment = odataObject.Segment ?? '';
        this.description = odataObject.Description ?? '';
    }
}

export class OperationResultClass {
    public success: boolean;
    public message?: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.success = odataObject.Success;
        this.message = odataObject.Message;
    }
}

export class ChannelAffiliationZoneClass {
    public ChannelId?: number;
    public AffiliationId?: number;
    public CountyId?: string;
    public StateId?: string;
    public CountryRegionId?: string;
    public LogisticsAddressCountyRecId?: number;
    public RecId?: number;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.ChannelId = odataObject.ChannelId;
        this.AffiliationId = odataObject.AffiliationId;
        this.CountyId = odataObject.CountyId;
        this.StateId = odataObject.StateId;
        this.CountryRegionId = odataObject.CountryRegionId;
        this.LogisticsAddressCountyRecId = odataObject.LogisticsAddressCountyRecId;
        this.RecId = odataObject.RecId;
    }
}

export class B2CEmailInfo {
    public TenantType: string;
    public Email: string;
    public Exists: boolean;
    public Blocked: boolean;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.TenantType = odataObject.TenantType;
        this.Email = odataObject.Email;
        this.Exists = odataObject.Exists;
        this.Blocked = odataObject.Blocked;
    }
}

export class OptionClass {
    public id: string;
    public name: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.id = odataObject.id ?? '';
        this.name = odataObject.name ?? '';
    }
}

export class CreditAdjustmentPaymentTerms {
    public PaymentTerm: string;
    public Description: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.PaymentTerm = odataObject.PaymentTerm ?? '';
        this.Description = odataObject.Description ?? '';
    }
}

export class GuaranteeInsuranceType {
    public Description: string;
    public Type: string;
    public DataAreaId: string;
    public RecId: number;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};

        this.Description = odataObject.Description ?? '';
        this.Type = odataObject.Type ?? '';
        this.DataAreaId = odataObject.DataAreaId ?? '';
        this.RecId = odataObject.RecId ?? 0;
    }
}
